const ITEMS = [
  "Kültüvatör",
  "Kaldıraç",
  "Çizel",
  "Terminatör",
  "Viper",
  "Tiller",
  "Ağır Patlatma",
  "Goble",
  "Katlamalı Goble",
  "Sap Parçalama",
  "Diskaro",
];

export default function Marquee() {
  return (
    <div
      className="relative overflow-hidden border-y border-white/10 bg-ink-deep py-4"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {ITEMS.map((item) => (
              <span key={`${half}-${item}`} className="flex items-center">
                <span className="px-7 font-display text-lg font-bold uppercase tracking-[0.18em] text-paper/75">
                  {item}
                </span>
                <span className="h-1.5 w-1.5 rotate-45 bg-gold" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}